import { useMemo } from "react"

const COLORS = ["#6366f1", "#8b5cf6", "#a78bfa", "#c4b5fd", "#7c3aed", "#4f46e5", "#818cf8"]

export const SpendByAudienceBar = ({ series }: { series: any[] }) => {
  const audienceSpend = useMemo(() => {
    const audiences = series ?? []

    const spendPerAudience = audiences.map((audience: any) => {
      const name: string = audience.name
      const dataPoints: [number, number][] = audience.data
      const total = dataPoints.reduce((sum, [, value]) => sum + value, 0)
      return { name, total }
    })

    const grandTotal = spendPerAudience.reduce((sum, a) => sum + a.total, 0)

    return spendPerAudience.map((audience, i) => ({
      name: audience.name,
      total: audience.total,
      percent: grandTotal > 0 ? Math.round((audience.total / grandTotal) * 100) : 0,
      color: COLORS[i % COLORS.length],
    }))
  }, [series])

  return (
    <ul className="list-unstyled personal-goals-list mb-0">
      {audienceSpend.map((audience) => (
        <li key={audience.name}>
          <div className="d-flex align-items-center">
            <div className="me-2">
              <span className="avatar avatar-rounded" style={{ backgroundColor: `${audience.color}20` }}>
                <i className="bi bi-people fs-18" style={{ color: audience.color }}></i>
              </span>
            </div>
            <div className="flex-fill">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="d-block fw-semibold">{audience.name}</span>
                <span className="d-block" style={{ color: "#8c9097" }}>
                  ${audience.total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
              </div>
              <div className="progress progress-animate progress-xs" style={{ backgroundColor: `${audience.color}20` }}>
                <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: `${audience.percent}%`, backgroundColor: audience.color }} />
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}
